import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useMarketplaceOrders = (page = 1, perPage = 15) =>
    useQuery({
        queryKey: ['marketplace-orders', page, perPage],
        queryFn: async () => {
            const res = await API.get('/marketplace-orders', {
                params: { page, per_page: perPage },
            })
            return res?.data
        },
        staleTime: 1000 * 60 * 2,
        retry: false,
    })

export default useMarketplaceOrders
